'use client';
import { isFunction } from '@s7/utils';
import { useMutationImpl } from './useMutation.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const createMutation = (definition, definitionOptions)=>{
    return (options)=>{
        const [mutate, _data] = useMutationImpl(_extends({}, definitionOptions, options));
        return [
            (options)=>mutate(isFunction(definition) ? definition(options) : definition),
            _data
        ];
    };
};

export { createMutation };
//# sourceMappingURL=createMutation.js.map
